import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Keyboard, CameraOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const REGION_ID = "ebik-qr-region";

export function QrScanner({ onResult }) {
  const scannerRef = useRef(null);
  const [camFailed, setCamFailed] = useState(false);
  const [manual, setManual] = useState("");

  useEffect(() => {
    let cancelled = false;
    const scanner = new Html5Qrcode(REGION_ID, { verbose: false });
    scannerRef.current = scanner;
    Html5Qrcode.getCameras()
      .then((cams) => {
        if (cancelled || !cams || cams.length === 0) { setCamFailed(true); return; }
        const camId = (cams.find((c) => /back|rear|environment/i.test(c.label)) || cams[0]).id;
        return scanner.start(camId, { fps: 10, qrbox: 220 },
          (text) => { onResult(text); },
          () => {});
      })
      .catch(() => setCamFailed(true));
    return () => {
      cancelled = true;
      const s = scannerRef.current;
      if (s && s.isScanning) { s.stop().then(() => s.clear()).catch(() => {}); }
    };
  }, [onResult]);

  return (
    <div>
      <div id={REGION_ID} data-testid="qr-region" className="rounded-lg overflow-hidden bg-black min-h-[200px] flex items-center justify-center">
        {camFailed && (
          <div className="text-center text-white/70 py-8 px-4">
            <CameraOff size={28} className="mx-auto mb-2" />
            <p className="text-xs">Camera unavailable in this environment.</p>
          </div>
        )}
      </div>
      <div className="mt-3">
        <Label className="flex items-center gap-1.5 text-xs"><Keyboard size={13} /> Or enter cargo code manually</Label>
        <div className="flex gap-2 mt-1.5">
          <Input data-testid="qr-manual-input" value={manual} onChange={(e) => setManual(e.target.value)} placeholder="EBK-2026-ZA9001" />
          <Button data-testid="qr-manual-go" onClick={() => manual && onResult(manual.trim())}>Confirm</Button>
        </div>
      </div>
    </div>
  );
}
